import { memo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { isNumber } from 'lodash';
// Import Components
import { PieChart, BusyLoader, Empty } from '@geneui/components';
import SectionWithTitle from 'components/common/SectionWithTitle';
// Import Constants
import { l } from 'constants/common';

const CampaignDataChart = ({ isLoading, data, title }) => {
    const { t } = useTranslation();
    const { anotherCount, successCount } = data;

    return (
        <SectionWithTitle title={title} hasContentPadding={false} contentClassName="c-r-v-swt-content">
            {isLoading ? (
                <BusyLoader spinnerSize="big" isBusy={true} />
            ) : isNumber(successCount) && isNumber(anotherCount) ? (
                <PieChart
                    decimalNumberPrecision={1}
                    fixedTooltipContent={''}
                    data={[
                        {
                            y: successCount,
                            color: '#01ecc5',
                            name: t(l.Success),
                        },
                        {
                            y: anotherCount,
                            color: '#fa0c54',
                            name: t(l.Failed),
                        },
                    ]}
                />
            ) : (
                <Empty title={t(l.NoDataToDisplay)} />
            )}
        </SectionWithTitle>
    );
};

CampaignDataChart.propTypes = {
    data: PropTypes.object.isRequired,
    isLoading: PropTypes.bool,
    title: PropTypes.string,
};

CampaignDataChart.defaultProps = {
    isLoading: false,
    title: '',
};

export default memo(CampaignDataChart);
